"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./Icon.css");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const RTL_MIRRORABLE_ICONS = ['align-left', 'align-right', 'arrow-double-left', 'arrow-double-right', 'arrow-end-left', 'arrow-end-right', 'arrow-left', 'arrow-right', 'bar-chart', 'chart-area', 'chart-bar-horizontal', 'chart-scatter', 'chart-waterfall', 'chevron-left', 'chevron-right', 'clipboard-list', 'external-link', 'file-certificate', 'file-edit', 'file-excel', 'file-import', 'file-export', 'file-image', 'file-signature', 'file-medical', 'file-medical-alt', 'file-pdf', 'file-plus', 'file-signature', 'file-text', 'file-user', 'file-word', 'flip', 'forward', 'help', 'indent', 'join-left', 'join-right', 'line-chart', 'list-view', 'outdent', 'redo', 'reply', 'share', 'sign-out', 'undo'];

/**
 * Display an icon by name.
 * @param {string} name
 */
const Icon = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    large,
    spin,
    name: nameProp,
    dir,
    ...rest
  } = props;
  let name = nameProp;
  let iconClasses = (0, _classnames.default)('ds-icon', `ds-${name}`, {
    'ds-icon--large': large,
    'ds-icon--spin': spin,
    'ds-icon--flipped': dir === 'rtl' && RTL_MIRRORABLE_ICONS.includes(name)
  }, props.className);
  if (nameProp === 'finances') {
    name = 'institution';
  }
  ;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    ref: ref
  }, rest, {
    className: iconClasses,
    dangerouslySetInnerHTML: {
      __html: '<use xlink:href="#ds-icon-' + name + '"></use>'
    }
  }));
});
Icon.propTypes = {
  /**
   * The identifier for which icon to display.
   */
  name: _propTypes.default.string.isRequired,
  /**
   * Increases to larger size if {true}.
   */
  large: _propTypes.default.bool,
  /**
   * Direction of the icon. rtl is the mirror image of ltr.
   */
  dir: _propTypes.default.oneOf(['ltr', 'rtl']),
  /**
   * Causes the icon to spin for loaders, gear, etc if {true}.
   */
  spin: _propTypes.default.bool,
  /**
   * Add additional class name to style icon.
   */
  className: _propTypes.default.string
};
Icon.defaultProps = {
  large: false,
  dir: 'ltr',
  spin: false
};
var _default = exports.default = Icon;